export const columnType ={
    numeric:'numeric',
    text:'text',
}

